import { FC, useState } from "react"
import { RootState } from "../../../../store"
import { connect } from "react-redux"
import { NavigationProps } from "../../../../types"
import { logout } from "../../../../actions/loginActions"
import AdminNavSection from "./AdminNavSection"
import { KLogo } from "kahuna-base-react-components"
import { useNavigate } from "react-router-dom"
import ProfileDropdownMenu from "../ProfileDropdownMenu"
import ChangeUserModal from "../../../ui/modals/ChangeUserModal"
import { fetchUserData } from "../../../../actions"
import { users } from "../../../../apis"
import { toast } from "react-toastify"
import { lang } from "../../../../constants/languages"
import { errorFilledToastOptions } from "../../../../constants"

const AdminNavigation: FC<NavigationProps> = (props) => {
  const [changeUserModalOpen, setChangeUserModalOpen] = useState(false)

  const navigate = useNavigate()

  const goBackToAccount = () => {
    users(`/go_back_to_account/`, "get")
      .then((resp) => {
        if (resp?.data?.token) {
          localStorage.setItem("token", resp.data.token)
          if (localStorage.getItem("cgba")) localStorage.removeItem("cgba")

          props.fetchUserData().then(() => {
            navigate("/")
          })
        } else {
          toast.error(lang.menu.change_user_modal.error_changing_user, errorFilledToastOptions)
        }
      })
      .catch(() => toast.error(lang.menu.change_user_modal.error_changing_user, errorFilledToastOptions))
  }

  return (
    <div
      className={"flex flex-col justify-between h-full"}
      style={{
        borderRight: "1px solid #F3F3F3"
      }}
    >
      <div className="flex flex-col grow gap-0">
        <div
          className="py-2.5 w-11 flex items-center justify-center cursor-pointer"
          onClick={() => {
            navigate("/")
          }}
        >
          <KLogo hoverEnabled width={44} height={44} logoColor="white" />
        </div>
        <AdminNavSection user={props.user} />
      </div>

      <div className="flex items-center justify-center">
        {/* <InfoSection />
        <SocialSection />*/}
        <ChangeUserModal
          open={changeUserModalOpen}
          setOpen={setChangeUserModalOpen}
          userMembers={props.user.userMembers}
          fetchUserData={props.fetchUserData}
        />
        <ProfileDropdownMenu
          isAdmin={true}
          setChangeUserModalOpen={setChangeUserModalOpen}
          goBackToAccount={goBackToAccount}
        />
      </div>
    </div>
  )
}

const mapStateToProps = (state: RootState) => {
  return { user: state.auth.user }
}

export default connect(mapStateToProps, { logout, fetchUserData })(AdminNavigation)
